export const titleHeader = 'ARGUS';
